// app/contact/layout.tsx
'use client';

import { ReactNode } from 'react';
import { Box } from '@mui/material';
import { motion } from 'framer-motion';

export default function ContactLayout({ children }: { children: ReactNode }) {
  return (
    <Box
      component={motion.div}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      sx={{
        minHeight: '100vh',
        background: (theme) => ({
          // Create an immersive background with multiple gradients
          background: `
            radial-gradient(circle at 0% 0%, rgba(96, 165, 250, 0.1) 0%, transparent 50%),
            radial-gradient(circle at 100% 0%, rgba(168, 85, 247, 0.1) 0%, transparent 50%),
            radial-gradient(circle at 50% 100%, rgba(236, 72, 153, 0.1) 0%, transparent 50%),
            ${theme.palette.background.default}
          `,
        }),
        position: 'relative',
        overflow: 'hidden',
        pt: { xs: 8, sm: 12 }, // Add padding to account for Navigation
        pb: { xs: 4, sm: 8 },
      }}
    >
      {/* Animated background elements */}
      <Box
        component={motion.div}
        animate={{
          scale: [1, 1.2, 1],
          rotate: [0, 90, 0],
        }}
        transition={{
          duration: 20,
          repeat: Infinity,
          ease: 'linear',
        }}
        sx={{
          position: 'fixed',
          top: '0%',
          left: '0%',
          width: '100%',
          height: '100%',
          background: (theme) => theme.custom.gradients.primary,
          opacity: 0.03,
          filter: 'blur(100px)',
          pointerEvents: 'none',
        }}
      />
      <Box
        component={motion.div}
        animate={{
          scale: [1.2, 1, 1.2],
          rotate: [90, 0, 90],
        }}
        transition={{
          duration: 20,
          repeat: Infinity,
          ease: 'linear',
        }}
        sx={{
          position: 'fixed',
          top: '0%',
          right: '0%',
          width: '100%',
          height: '100%',
          background: (theme) => theme.custom.gradients.secondary,
          opacity: 0.03,
          filter: 'blur(100px)',
          pointerEvents: 'none',
        }}
      />

      {/* Content */}
      <Box
        sx={{
          position: 'relative',
          zIndex: 1,
        }}
      >
        {children}
      </Box>
    </Box>
  );
}